import cx from "classnames"
import PropTypes from "prop-types"
import { Text } from "components/Text"
import { useTranslator } from "components/Translator"
import { Price } from "components/Price"

export function FeesTotal(props) {
  const { className, amount, currency, unit, ...rest } = props
  const translator = useTranslator()
  const classNames = cx("space-y-4", className)

  return (
    <div className={classNames} {...rest}>
      <div className="flex flex-col space-x-2 lg:flex-row lg:items-center justify-between border-t pt-4 border-grey-light">
        <Text variant="headline4">{translator.trans("Total", {}, "fees")}</Text>
        <div className="space-x-1 flex flex-row items-center">
          <Text variant="headline4">
            <Price amount={amount} currency={currency} />
          </Text>
          {unit ? <Text variant="caption">{unit}</Text> : null}
        </div>
      </div>
    </div>
  )
}

FeesTotal.propTypes = {
  amount: PropTypes.number.isRequired,
  currency: PropTypes.string.isRequired,
  unit: PropTypes.string,
}
